import { useCallback } from "react";
import apiClient2 from "../api/apiClient2";

export function useUpdateUserPreferences() {
  const updateGrade = useCallback(async (grade: string) => {
    if (!grade) return;
    try {
      await apiClient2.put("/updateUserPreferences", { grade });
    } catch (err) {
      console.error("Failed to update user preferences:", err);
    }
  }, []);

  return { updateGrade };
}
